import formaters from "vincent-utils/dist/formaters.js";
class HMObject {
    constructor(param) {
        if (param instanceof HMObject) {
            this.value = param.valueOf();
        }
        else if (this.isHMObjectDTO(param)) {
            this.value = param.heure * 60 + param.minute;
        }
        else if (this.isHourMinuteObj(param)) {
            this.value = param.hour * 60 + param.minute;
        }
        else if (typeof param === "number") {
            this.value = param;
        }
        else if (typeof param === "string") {
            const candidate = formaters.getHeureMinuteObjectFromHoraireString(param);
            if (candidate) {
                this.value = candidate.heure * 60 + candidate.minute;
            }
            else {
                throw new Error("invalid string provided to HMObject contstructor");
            }
        }
        else if (!param) {
            this.value = 0;
        }
        else {
            throw new Error("invalid constructor" + param);
        }
    }
    get minute() {
        return this.getMinute();
    }
    get heure() {
        return this.getHeure();
    }
    get hour() {
        return this.getHeure();
    }
    valueOf() {
        return this.value;
    }
    add(param) {
        if (this.isHMObjectDTO(param)) {
            this.value += param.heure * 60 + param.minute;
        }
        if (typeof param === "number") {
            this.value += param;
        }
        if (param instanceof HMObject) {
            this.value += param.valueOf();
        }
        return this;
    }
    addWithClone(param) {
        return this.clone().add(param);
    }
    isHMObjectDTO(param) {
        return (param != null &&
            typeof param === "object" &&
            "heure" in param &&
            "minute" in param);
    }
    isHourMinuteObj(param) {
        return (param != null &&
            typeof param === "object" &&
            "hour" in param &&
            "minute" in param);
    }
    getHeure() {
        return Math.floor(this.value / 60);
    }
    getMinute() {
        return this.value - this.getHeure() * 60;
    }
    getHMObjDTO() {
        return {
            heure: this.getHeure(),
            minute: this.getMinute(),
        };
    }
    getHourMinuteDTO() {
        return {
            hour: this.getHeure(),
            minute: this.getMinute(),
        };
    }
    toString() {
        if (this.value === null) {
            return "";
        }
        return (this.getHeure() +
            ":" +
            formaters.convertZeroToDoubleZero(this.getMinute()));
    }
    isBeforeOrEqual(param) {
        return this.valueOf() - new HMObject(param).valueOf() <= 0;
    }
    isBefore(param) {
        return this.valueOf() - new HMObject(param).valueOf() < 0;
    }
    isAfterOrEqual(param) {
        return this.valueOf() - new HMObject(param).valueOf() >= 0;
    }
    isAfter(param) {
        return this.valueOf() - new HMObject(param).valueOf() > 0;
    }
    typeName() {
        return "HMObject";
    }
    equals(param) {
        return this.value === new HMObject(param).valueOf();
    }
    minus(param) {
        return this.value - new HMObject(param).valueOf();
    }
    minusWithClone(param) {
        return new HMObject(this.value - new HMObject(param).valueOf());
    }
    clone() {
        return new HMObject(this.value);
    }
}
export { HMObject };
//# sourceMappingURL=HMObject.js.map